<template>
  <div class="plan-card" @click="$emit('select', plan)">
    <div class="care-type">
      {{  plan.name }}
      <div class="care-type-overview">
        {{  plan.overview }}
      </div>
    </div>
    <div class="pricing">
      <h3>£{{ (plan.monthly_amount + upcost).toFixed(2) }}</h3>
      <p>per month</p>
    </div>
    <div class="features">
      <ul class="bullet-points">
        <li v-for="feature in features" :key="feature.id">
          <span class="material-icons green" v-if="checkIncludes(feature.id)">check_circle_outline</span>
          <span class="material-icons red" v-else>highlight_off</span>
          <span>{{ feature.name }}</span>
        </li>
      </ul>
    </div>
    <div class="selector">
      Select this plan
    </div>
  </div>
</template>

<script>
export default {
  name: "PlanCard",
  props: {
    plan: {
      type: Object,
      required: true,
    },
    upcost: {
      type: Number,
      default: 0,
    },
    features: {
      type: Array,
      default(){
        return [];
      }
    },
  },
  methods: {
    checkIncludes(id){
      for (let i = 0; i < this.plan.features.length; i++){
        if (this.plan.features[i].id === id){
          return true;
        }
      }
      return false;
    }
  }
}
</script>

<style lang="scss" scoped>
.plan-card {
  text-align: center;
  border-radius: 10px;
  font-family: sans-serif;
  margin: 1rem 0 0 1rem;
  cursor: pointer;
  min-width: 340px;
  transition: 0.2s;
  &:hover{
    transform: scale(1.02);
    transition: 0.2s;

    .selector{
      color: #ffffff;
      transition: 0.2s;
    }
  }

  .care-type {
    border-radius: 10px 10px 0 0;
    padding: 0.7rem 0.5rem;
    background-color: #005EAE;
    color: #FFFFFF;
    font-size: 1.7rem;
  }

  .care-type-overview {
    padding: 0.5rem 0;
    color: #FFFFFF;
    font-size: 1rem;
  }

  .pricing {
    background-color: #1E73BE;
    color: #FFFFFF;
    padding: 0.4rem 0;

    h3 {
      margin: 0;
      font-size: 5rem;
      font-weight: normal;
      line-height: 5rem;
      color: #FFF;
    }
    p {
      font-size: 1.5rem;
      color: #859999;
      margin: 0;
    }
  }
  .features{
    background-color: #F5F5F5;
    padding: 0.5rem 1rem;
    .bullet-points{
      margin: 0;
      text-align: left;
      list-style: none;
      li{
        padding-bottom: 0.2rem;
        margin-bottom: 0.2rem;
        border-bottom: 1px dashed #D3D3D3;
        font-size: 1rem;
        display: flex;
        span{
          align-self: center;
        }
        .material-icons{
          margin-right: 0.5rem;
        }
      }
    }
  }
  .selector{
    background-color: #005EAE;
    border-radius: 0 0 10px 10px;
    color: #1E73BE;
    font-weight: bold;
    padding: 0.7rem 0;
    transition: 0.2s;
  }
}
.red{
  color: red;
}
.green{
  color: green;
}

@media only screen and (max-width: 860px) {
  .plan-card{
    margin: 1rem 0 0 0;
  }
}

@media only screen and (max-width: 500px) {
  .plan-card{
    max-width: 90%;
    min-width: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PlanCard.vue